import script from "./ProjectMerit.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectMerit.vue?vue&type=script&setup=true&lang=js"

import "./ProjectMerit.vue?vue&type=style&index=0&id=00f853f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00f853f8"]])

export default __exports__